import { useTranslation } from 'react-i18next';
import IconEmpty from '../../../../assets/Images/icons/empty';
import Sticky from 'react-sticky-el';
import classNames from 'classnames';
import { POLICY_NAME } from '../../POLICY';

const StepList = ({
    setCurrentSelectList,
    currentSelectList,
    SW,
    ...props
}) => {
    const data = [
        {
            name: 'ข้อมูลที่จำเป็นต้องระบุ',
            key: 1,
        },
        { name: 'เนื้อหาเอกสาร', key: 2 },

        // { name: 'policy.des9', key: 8 },
    ];

    const { t } = useTranslation(['translation', POLICY_NAME.DPA]);

    const { step1, step2 } = props.steps;

    const validateStep = (key) => {
        SW?.goToStep(key);
    };
    const validateStepColor = (key) => {
        if (key === 1 && step1) {
            return true;
        }
        if (key === 2 && step2) {
            return true;
        }

        return false;
    };

    return (
        <div className="col-span-1">
            <Sticky onFixedToggle={(e) => props.setFixed(e)}>
                <div className="bg-white rounded-md shadow-sm pt-5 pb-5">
                    <div
                        style={{
                            borderBottom: '1px solid #ECECEC',
                        }}
                        className="text-xs font-semibold text-purple-PHX px-5 pb-4"
                    >
                        {t('Category')}
                    </div>
                    {data?.length > 0 ? (
                        data.map((e, i) => {
                            return (
                                <button
                                    type="button"
                                    key={i}
                                    className={`custom-list cursor-pointer text-left w-full ${
                                        currentSelectList === e.key
                                            ? 'select'
                                            : ''
                                    }`}
                                    onClick={() => {
                                        setCurrentSelectList(e?.key);
                                        validateStep(e?.key);
                                    }}
                                >
                                    <div />
                                    <div className="my-4 flex w-full items-center">
                                        <div className="flex-1 space-y-2">
                                            <div className="font-semibold text-xs flex justify-between items-center">
                                                <span>{e.name}</span>
                                                <div
                                                    className={classNames(
                                                        'bg-[#DBDBDB] rounded-full flex-shrink-0',
                                                        ' flex items-center justify-center w-5 h-5',
                                                        {
                                                            '!bg-[#4ACE8F]':
                                                                validateStepColor(
                                                                    e.key
                                                                ),
                                                        }
                                                    )}
                                                >
                                                    <svg
                                                        width="10"
                                                        height="8"
                                                        viewBox="0 0 10 8"
                                                        fill="none"
                                                        xmlns="http://www.w3.org/2000/svg"
                                                    >
                                                        <path d="M9.47346 0.806574C9.41149 0.744088 9.33775 0.694492 9.25651 0.660646C9.17527 0.6268 9.08814 0.609375 9.00013 0.609375C8.91212 0.609375 8.82498 0.6268 8.74374 0.660646C8.66251 0.694492 8.58877 0.744088 8.5268 0.806574L3.56013 5.77991L1.47346 3.68657C1.40911 3.62441 1.33315 3.57554 1.24992 3.54274C1.16668 3.50993 1.0778 3.49385 0.988344 3.49539C0.89889 3.49694 0.810617 3.51609 0.728565 3.55176C0.646513 3.58742 0.572288 3.63889 0.510129 3.70324C0.44797 3.76759 0.399094 3.84355 0.366292 3.92679C0.333489 4.01002 0.317402 4.09891 0.31895 4.18836C0.320497 4.27781 0.339649 4.36609 0.375311 4.44814C0.410974 4.53019 0.462448 4.60441 0.526796 4.66657L3.0868 7.22657C3.14877 7.28906 3.22251 7.33866 3.30375 7.3725C3.38498 7.40635 3.47212 7.42377 3.56013 7.42377C3.64814 7.42377 3.73527 7.40635 3.81651 7.3725C3.89775 7.33866 3.97149 7.28906 4.03346 7.22657L9.47346 1.78657C9.54113 1.72415 9.59514 1.64838 9.63208 1.56404C9.66901 1.47971 9.68808 1.38864 9.68808 1.29657C9.68808 1.20451 9.66901 1.11344 9.63208 1.0291C9.59514 0.94477 9.54113 0.869002 9.47346 0.806574Z" />
                                                    </svg>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </button>
                            );
                        })
                    ) : (
                        <div className="h-[54vh] grid items-center justify-center">
                            <div className="-mt-16">
                                <IconEmpty />
                            </div>
                        </div>
                    )}
                </div>
            </Sticky>
        </div>
    );
};

export default StepList;
